export default __webpack_public_path__ + "static/media/illustrated-background-desktop.6936077f.svg";